import { Settings } from "react-feather";
import {
  FaHistory,
  FaUsers,
  FaPaste,
  FaCommentsDollar,
  FaRegClipboard,
  FaChartBar,
  FaRegArrowAltCircleRight,
  FaTasks,
  FaCodeBranch,
  FaUserPlus,
  FaUserCog,
  FaWallet,
  FaUserFriends,
  FaUserTie,
  FaCloudDownloadAlt
} from "react-icons/fa";
export const MENUITEMS = [
  {
    path: "/dashboard",
    title: "s_dashboard",
    icon: FaHistory,
    type: "link",
  },
  // {
  //   title: "Admin",
  //   icon: FaUserTie,
  //   type: "sub",
  //   active: false,
  //   children: [{ path: "/List_Admin", title: "List Admins", type: "link" }],
  // },
  {
    title: "Branches",
    icon: FaCodeBranch,
    type: "sub",

    children: [
      {
        path: "/Branch/list_Branch",
        title: "List Branches",
        type: "List Branches",
      },
    ],
  },
  {
    title: "Agents",
    icon: FaUserPlus,
    type: "sub",

    children: [
      { path: "/Agent/Agent_List", title: "Agents_List", type: "link" },
    ],
  },
  {
    title: "Contract List",
    icon: FaPaste,
    type: "sub",

    children: [
      {
        path: "/list_all_sell_contracts",
        title: "Sell Contracts",
        type: "link",
      },
      {
        path: "/list_all_rent_contracts",
        title: "Rent Contracts",
        type: "link",
      },
    ],
  },
  // {
  //   title: "Fast contracts",
  //   icon: FaPaste,
  //   type: "sub",
  //   active: false,
  //   children: [
  //     {
  //       path: "/list_all_sell_contracts_fast",
  //       title: "Fast-selling contracts",
  //       type: "link",
  //     },
  //     {
  //       path: "/list_all_rent_contracts_fast",
  //       title: "Fast rental contracts",
  //       type: "link",
  //     },
  //   ],
  // },
  {
    title: "List of Bills",
    icon: FaRegClipboard,
    type: "sub",

    children: [
      {
        path: "/list_takemoney",
        title: "list taking money",
        type: "link",
      },
      {
        path: "/list_paradn",
        title: "Payments List",
        type: "link",
      },
      {
        path: "/list_scurety",
        title: "Security Bill List",
        type: "link",
      },
      // {
      //   path: "/list_customers_anket",
      //   title: "List of Seller Anket",
      //   type: "link",
      // },
      // {
      //   path: "/List_Writers",
      //   title: "List of Scripts",
      //   type: "link",
      // },
    ],
  },
  {
    title: "Tenants_",
    icon: FaUsers,
    type: "sub",

    children: [
      {
        path: "/List_Tenants",
        title: "List of Tenants",
        type: "link",
      },
    ],
  },
  {
    title: "list of clients",
    icon: FaUserFriends,
    type: "sub",
    active: false,
    children: [
      {
        path: "/List_sellers_buyers",
        title: "list of clients",
        type: "link",
      },
    ],
  },
  {
    title: "Sent To Do",
    icon: FaTasks,
    type: "sub",

    children: [{ path: "/todo_agent_list", title: "Sent To Do", type: "link" }],
  },

  // {
  //   title: "Customer Detail",
  //   icon: FaInfoCircle,
  //   type: "sub",

  //   children: [
  //     {
  //       path: "/List_Customer_Detail",
  //       title: "Customer Detail List",
  //       type: "link",
  //     },
  //   ],
  // },
  {
    title: "Accounting",
    icon: FaCommentsDollar,
    type: "sub",

    children: [
      {
        path: "/list_salary",
        title: "List Salary",
        type: "link",
      },
      {
        path: "/List_Form_persentage",
        title: "Persentage Payment Form",
        type: "link",
      },
      {
        path: "/List_Form_Salary",
        title: "Salary Payment Form",
        type: "link",
      },
      {
        path: "/List_bounes",
        title: "Reward and Punishment Form",
        type: "link",
      },
    ],
  },
  {
    title: "Expenses",
    icon: FaWallet,
    type: "sub",

    children: [
      {
        path: "/list_BranchMasrufat",
        title: "Expenses List",
        type: "link",
      },
      {
        path: "/List_type_exp",
        title: "Create Cost",
        type: "link",
      },
    ],
  },
  {
    title: "s_reports",
    icon: FaChartBar,
    type: "sub",

    children: [
      {
        path: "/All_Project_Report",
        title: "Accounting Report",
        type: "link",
      },
      {
        path: "/All_Box_Report",
        title: "Box Report",
        type: "link",
      },
      {
        path: "/income_report",
        title: "Income Report",
        type: "link",
      },
      {
        path: "/agent_performance",
        title: "Employee General Report",
        type: "link",
      },
      {
        path: "/Sell_Taj_Report",
        title: "Sales Contract Report",
        type: "link",
      },
      {
        path: "/Rent_Taj_Report",
        title: "Rental contract report",
        type: "link",
      },
    ],
  },
  {
    title: "archive",
    icon: Settings,
    type: "sub",
    children: [
      { path: "/List_delete_Sell", title: "Sell Contracts", type: "link" },
      { path: "/List_delete_Rent", title: "Rent Contracts", type: "link" },
      {
        path: "/List_delete_takemoney",
        title: "list taking money",
        type: "link",
      },
      { path: "/List_delete_payments", title: "Payments List", type: "link" },
      { path: "/List_delete_tenants", title: "List of Tenants", type: "link" },
    ],
  },
  {
    title: "backup",
    icon: FaCloudDownloadAlt,
    type: "sub",

    children: [
      {
        path: "/back_up",
        title: "List Backup",
        type: "link",
      },
    ],
  },
  {
    title: "s_profile",
    icon: FaUserCog,
    type: "sub",
    children: [
      { path: "/UserProfile", title: "s_profile", type: "link" },
      { path: "/settings/profile", title: "Update Profile", type: "link" },
    ],
  },
  {
    title: "s_logout",
    icon: FaRegArrowAltCircleRight,
    type: "sub",
    children: [{ path: "/", title: "s_logout", type: "logout_sub" }],
  },
];
